import axios from 'axios';

const axiosInstance = axios.create();

export default axiosInstance;

axiosInstance.interceptors.request.use((request) => {
  try {
    const csrfToken = document.getElementsByName('csrf-token')[0].content;
    request.withCredentials = true;

    if (csrfToken) {
      request.headers['X-CSRF-Token'] = csrfToken;
    }

    return request;
  } catch (error) {
    throw new Error(`axios# Problem with request during pre-flight phase: ${error}.`);
  }
});
